<template>
  <div v-if="loading" class="content">
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div v-else class="content">
    <div class="md-layout">
      <div class="md-layout">
        <div
          v-if="this.document_categories.length > 0"
          class="
            md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100
          "
        >
          <md-card>
            <md-card-header data-background-color="green">
              <h4 class="title">Selecione a Pasta</h4>
            </md-card-header>
            <md-card-content />
          </md-card>
        </div>

        <div
          v-for="category in this.document_categories"
          :key="category.id"
          class="md-layout-item md-medium-size-50 md-xsmall-size-50 md-size-25"
          @click="selectList1(category.id)"
        >
          <md-card class="md-card-profile">
            <md-card-content>
              <h4 class="category text-gray">
                {{ category.name }}
              </h4>
              <img
                v-if="filter_id == category.id || filter_id == null"
                class="img"
                src="https://i.ibb.co/qdjn30T/knowbase.png"
              />
              <img
                v-else
                class="img"
                src="https://i.ibb.co/qdjn30T/knowbase.png"
                style="opacity: 0.5"
              />
            </md-card-content>
          </md-card>
        </div>
      </div>

      <!-- <div class="md-layout">
        <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-15" v-for="category in this.document_categories" @click="selectList1(category.id)" >
          <md-card class="md-card-profile" >
            <md-card-content>
              <h4 class="category text-gray">{{category.name}}</h4>
              <img class="img" src="https://i.ibb.co/qdjn30T/knowbase.png" v-if="filter_id==category.id || filter_id==null" />
              <img class="img" src="https://i.ibb.co/qdjn30T/knowbase.png" v-else style="opacity:0.5"/>
            </md-card-content>
          </md-card>
        </div>
    </div> -->

      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Documentos Anexos</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-list>
                <!-- <md-list-item v-for="doc in this.documentList" :href="doc.filepath" v-if=" (doc.category_type==filter_type && doc.category_id==filter_id) "> -->
                <md-list-item
                  v-for="doc in this.documentList"
                  :key="doc.filepath"
                  :href="doc.filepath"
                >
                  <md-icon>file_present</md-icon>
                  <div class="md-list-item-text">
                    {{ doc.filename }}
                  </div>
                </md-list-item>
              </md-list>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { EntityCard } from "@/pages";
import { userService } from "../_services";
import { getUserSession } from "../_services/localstorage";

export default {
  components: {
    EntityCard,
  },
  data() {
    return {
      id: 0,
      glpiActiveEntity: 0,
      loading: true,
      ticketInfo: {},
      status: 0,
      approval: 0,
      documents: [],
      documentListSwap: [],
      documentList: [],
      tasks: [],
      taskList: [],
      filter_type: "Entity",
      filter_id: null,
      document_categories: [],
    };
  },
  created: function () {
    this.loading = true;
    // console.log(this.id)
    this.user = getUserSession();
    this.glpiActiveEntity = this.user.activeentity;

    // console.log(this.user);

    userService
      .getObjectItem(
        "Entity",
        this.glpiActiveEntity,
        "Document_Item",
        "?range=0-9990&get_hateoas=false",
      )
      .then((data) => {
        (this.documents = data), this.checkDocuments();
      });

    // console.log(this.user);
    // console.log(this.glpiActiveEntity);
    this.timer = setInterval(this.checkSite, 1000);
  },
  methods: {
    selectList1: function (x) {
      this.filter_id = x;
      if (this.documents.length > 0) {
        this.documentList = [];
        for (var i = 0; i < this.documents.length; i++) {
          if (
            this.documents[i].items_id == x &&
            this.documents[i].itemtype == "KnowbaseItem"
          ) {
            userService
              .getObject(
                this.user.token,
                "Document",
                this.documents[i].documents_id,
              )
              .then((data) => {
                // this.loading=true;
                this.documentList.push({
                  date: data.date_creation,
                  category_id: null,
                  category_type: null,
                  filename: data.filename,
                  filepath: "https://sgi.green4t.com/files/" + data.filepath,
                });
                setTimeout(() => {
                  this.loading = false;
                }, 100);
              });
          }
        }
      }
    },
    strip: function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },
    checkDocuments: function () {
      if (this.documents.length > 0) {
        var swapIDs = [];
        for (i = 0; i < this.documents.length; i++) {
          if (this.documents[i].itemtype == "KnowbaseItem") {
            swapIDs.push(this.documents[i].items_id);
          }
        }
        //Get distict states
        swapIDs = [...new Set(swapIDs)];

        this.document_categories = [];

        for (var i = 0; i < swapIDs.length; i++) {
          userService
            .getObject(this.user.token, "KnowbaseItem", swapIDs[i])
            .then((data) => {
              // this.loading=true;
              this.document_categories.push({
                name: data.name,
                id: data.id,
              });
              console.log(this.document_categories);
              setTimeout(() => {
                this.loading = false;
              }, 100);
            });
        }
      }

      if (this.documents.length > 0) {
        this.documentList = [];
        for (var i = 0; i < this.documents.length; i++) {
          if (this.documents[i].itemtype == "Entity") {
            userService
              .getObject(
                this.user.token,
                "Document",
                this.documents[i].documents_id,
              )
              .then((data) => {
                // this.loading=true;
                this.documentList.push({
                  date: data.date_creation,
                  category_id: null,
                  category_type: null,
                  filename: data.filename,
                  filepath: "https://sgi.green4t.com/files/" + data.filepath,
                });
                setTimeout(() => {
                  this.loading = false;
                }, 100);
              });
          }
        }
      }
    },
    checkSite: function () {
      this.loading = false;
      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      if (this.user.activeentity != this.glpiActiveEntity) {
        this.glpiActiveEntity = this.user.activeentity;
        this.loading = true;

        userService
          .getObjectItem(
            "Entity",
            this.glpiActiveEntity,
            "Document_Item",
            "?range=0-9990&get_hateoas=false",
          )
          .then((data) => {
            (this.documents = data), this.checkDocuments();
          });

        // console.log("Search1");
      }
    },
  },
};
</script>

<style>
.float2 {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
}

.my-float2 {
  margin-top: 16px;
}
</style>
